// Importing necessary libraries and components
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import isEmpty from "lodash/isEmpty";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import { Typography } from "@material-ui/core";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import MenuList from "@material-ui/core/MenuList";
import { exportToPDF } from "modules/reports/utils/common";
import { withStyles } from "@material-ui/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { useDispatch } from "react-redux";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SyncIcon from "@material-ui/icons/Sync";
import { useSnackbar } from "notistack";
import { isArray } from "lodash";
import { exportToCSVProvider, MgStatus } from "../../Utils/commonUtils";
import noDataImage from "../../assets/img/noDataImage.png";
import SearchDialogManager from "../../components/DialogBox/SearchDialogManager";
import SearchFields from "../../components/SearchComponent/SearchFields";
import SearchChips from "../../components/SearchComponent/SearchChips";
import { changeSingleStatus } from "../../Redux/Actions/ProvideRegistration";
import { getMerchantListDataExport } from "../../Redux/Actions/merchantInformation";
import tableStyle from "../../assets/jss/material-dashboard-react/components/reportTables";
import { actionPermission, permissionCheck } from "../../Utils/commonUtils";
import { ReactComponent as ExportIcon } from "../../assets/svgIcons/ExportIcon.svg";
import { ReactComponent as AddIconSvg } from "../../assets/svgIcons/AddIconSvg.svg";
import {
  sendInviteApiCall,
  sendInviteManagerApiCall,
  submitManagerApiCall,
  reSendInviteManagerApiCall,
  submitIPAddressApiCall,
} from "../../actions/Operations";
import {
  getMerchantListData,
  getManagerListData,
  emptyReduxState,
  getManagerListDataByID,
  setFormDataManager,
  clearFormDataManager,
  getManagerListDataNames,
  getEmailData1,
  getRtpAch,
  getMerchantGroupCodePortfolios,
  emptyGroupCodeReduxState,
} from "../../Redux/Actions/merchantInformation";
import InviteManagerModal from "../../components/Modal/InvitemanagerModal";
import WhitelistedApiModal from "../../components/Modal/WhitelistedApiModal";
import { profileCodePermissionCheck } from "../../Utils/commonUtils";
import ManagerSetupMenu from "../../components/Menu/ManagerSetupMenu";

// Custom Tooltip styling
const IconsTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#000",
    fontSize: "12px",
  },
  tooltipPlacementTop: {
    margin: "4px 0",
  },
}))(Tooltip);

// Custom styles for the table
const useStyles = makeStyles(tableStyle);

// Function to create data rows for the table
function createData(
  Business_Name,
  Manager_name,
  Manager_uid,
  Email,
  First_Name,
  Last_Name,
  Phone_Number,
  Business_Phone,
  Updated_date,
  Status_Code,
  Bussines_id,
  Status_Code_Value,
  Type,
  Platform_Accessibility,
  Account_Accessibility,
  Group_Visibility,
  User_Merchant_AcctLinks_Details,
  Id,
  Manager_ID,
  full_name,
  Users_Details,
  Created_By,
  Allowed_IP,
  First_Manager,
  MainEmail
) {
  return {
    Business_Name,
    Manager_name,
    Manager_uid,
    Email,
    First_Name,
    Last_Name,
    Phone_Number,
    Business_Phone,
    Updated_date,
    Status_Code,
    Bussines_id,
    Status_Code_Value,
    Type,
    Platform_Accessibility,
    Account_Accessibility,
    Group_Visibility,
    User_Merchant_AcctLinks_Details,
    Id,
    Manager_ID,
    full_name,
    Users_Details,
    Created_By,
    Allowed_IP,
    First_Manager,
    MainEmail,
  };
}

// Pagination actions for the table
function TablePaginationActions(props) {
  const classes = useStyles();
  const theme = useTheme();

  const {
    count, page, rowsPerPage, onPageChange,
  } = props;

  // Handlers for pagination buttons
  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.rootPagination}>
      {/* First Page Button */}
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        variant="body2"
        aria-label="first page"
      >
        {theme.direction === "rtl" ? (
          <Typography>Last</Typography>
        ) : (
          <Typography variant="body2">First</Typography>
        )}
      </IconButton>
      {/* Previous Page Button */}
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <Typography>Previous</Typography>
        ) : (
          <Typography variant="body2">Previous</Typography>
        )}
      </IconButton>
      {/* Current Page Indicator */}
      <IconButton
        onClick={handleFirstPageButtonClick}
        aria-label="first page"
        className={classes.bottonPage}
      >
        <Typography variant="body2">{page ? page + 1 : 1}</Typography>
      </IconButton>
      {/* Next Page Button */}
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <Typography variant="body2">Next</Typography>
        )}
      </IconButton>
      {/* Last Page Button */}
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? (
          <FirstPageIcon />
        ) : (
          <Typography variant="body2">Last</Typography>
        )}
      </IconButton>
    </div>
  );
}

// PropTypes validation for TablePaginationActions
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

// Enhanced table head for sorting and displaying column headers
function EnhancedTableHead(props) {
  const {
    classes, order, orderBy, onRequestSort,
  } = props;

  // Handler for sorting columns
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  // Define table headers
  const headCells = [
    {
      id: "Business_Name",
      numeric: false,
      disablePadding: true,
      label: "Business Name",
      headClassName: classes.DBA_Name,
    },
    {
      id: "Manager_name",
      numeric: false,
      disablePadding: false,
      label: "Manager Name",
      headClassName: classes.Assign_To,
    },
    {
      id: "Manager_Type",
      numeric: false,
      disablePadding: false,
      label: "Manager Type",
      headClassName: classes.Assign_To,
    },
    {
      id: "Manager_uid",
      numeric: false,
      disablePadding: false,
      label: "Manager UID",
      headClassName: classes.Assign_To,
    },
    {
      id: "Email",
      numeric: true,
      disablePadding: false,
      label: "Email Address",
      headClassName: classes.email,
    },
    {
      id: "Phone_Number",
      numeric: true,
      disablePadding: false,
      label: "Phone Number",
      headClassName: classes.Phone,
    },
    {
      id: "Updated_date",
      numeric: true,
      disablePadding: false,
      label: "Updated Date",
      headClassName: classes.Phone,
    },
    {
      id: "Platform",
      numeric: true,
      disablePadding: false,
      label: "Platform",
      headClassName: classes.Phone,
    },
    {
      id: "RTP_Status",
      numeric: false,
      disablePadding: false,
      label: "Status",
      headClassName: classes.status,
    },
    {
      id: "blank",
      numeric: false,
      disablePadding: false,
      label: "",
      headClassName: classes.status,
    },
  ];

  return (
    <TableHead className={classes.tableHeader}>
      <TableRow>
        {/* Render table headers */}
        {headCells.map((headCell, index) => (
          <TableCell
            key={index}
            className={classes.cellTextHeaderOffer}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

// PropTypes validation for EnhancedTableHead
EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

// Main component for rendering the Manager List report
const ProviderReport = (props) => {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("Updated_date");
  const [selected, setSelected] = React.useState([]);
  const [chipValue, setChipValue] = React.useState([]);
  const theme = useTheme();

  const windowWidth = useMediaQuery(theme.breakpoints.up("md"));
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [searchBar, setSearchBar] = React.useState(false);
  const [openImportFileModal, setImportFileModalOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const profileId = localStorage.getItem("profileId");
  const menu = JSON.parse(localStorage.getItem("menu"));
  const dispatch = useDispatch();
  const [inviteManagerModalOpen, setInviteManagerModalOpen] =
    React.useState(false);
  const [whitelistedApiModalOpen, setWhitelistedApiModalOpen] =
    React.useState(false);

  const [transformedData, setTransformedData] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const completeData = props?.managerListData?.managerListNames;

  const [totalCount, setTotalCount] = React.useState(0);
  const [rowForEdit, setRowForEdit] = React.useState("");
  const [openStatusRowId, setOpenStatusRowId] = React.useState(null);
  const [statusAnchorEl, setStatusAnchorEl] = React.useState(null);

  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const profileCode = menu?.Role_Permission_Data?.Profile_Code;
  const { enqueueSnackbar } = useSnackbar();

  const handleAddIconClick = (value) => {

    // Ignore React click events
    if (value?.nativeEvent || value?._reactName) {
      console.warn("React event received instead of row", value);
      return;
    }

    setRowForEdit(value);
    props.getRtpAch();
    setInviteManagerModalOpen(true);
  };
  const handleApiModalClick = (value) => {
    setRowForEdit(value);
    if (id == null || value !== null) {
      localStorage.removeItem("businessName");
    }
    setWhitelistedApiModalOpen(true);
  };
  const handleWebhookModalClick = (value) => {
    setRowForEdit(value);
    if (id == null || value !== null) {
      localStorage.removeItem("businessName");
    }
    props.getRtpAch();
  };

  const handleToggle = () => {
    setImportFileModalOpen((prevOpen) => !prevOpen);
  };

  const handleCloseModel = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setImportFileModalOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setImportFileModalOpen(false);
    }
  }

  const handleSearchOpen = () => {
    setSearchBar(true);
  };

  const handleSearchClose = () => {
    setSearchBar(false);
  };

  React.useEffect(() => {
    if (menu?.Email) {
      dispatch(getEmailData1(menu?.Email));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const Manager_Id = menu?.Manager_Id;
    if (id) {
      const payloadWhenId = {
        Bussines_id: id,
        recordPerPage: 999999,
      };
      dispatch(getManagerListDataNames(payloadWhenId));
    } else if (id == null) {
      let payload = null;
      if (profileId === null || profileId === "null") {
        payload = {
          Manager_Id,
          recordPerPage: 999999,
        };
      } else {
        payload = {
          Profile_Id: profileId,
          recordPerPage: 999999,
        };
      }
      dispatch(getManagerListDataNames(payload));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  React.useEffect(
    () => () => {
      const updatedFormData = {
        searchBusinessName: "",
        searchEmail: "",
        searchStatus: "",
        searchManagerUID: "",
        searchManagerName: "",
        searchManagerId: "",
        searchPlatform: "",
        searchManagerType: "",
      };
      props.setFormDataManager(updatedFormData);
      props.clearFormDataManager();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  React.useEffect(() => {
    const result = completeData?.data?.map((items) => ({
      Business_Name: items?.Business_Details?.Business_Name,
      Email: items?.Email,
      Manager_uid: items.Manager_uid,
      _id: items?._id,
      First_Name: items?.First_Name,
      Last_Name: items?.Last_Name,
      Phone_Number: items?.Phone_Number,
      Updated_date: items?.ManagerStatus?.Updated_date,
      Status_Code: items?.ManagerStatus?.Status
        ? items?.ManagerStatus?.Status
        : null,
      User_Id: items.Manager_Details?.User_Id,
      Bussines_id: items?.Business_Details?._id,
      Manager_name: items?.full_name,
      Status_Code_Value: items?.Business_Details?.Status_Code,
      Type: items?.Type,
      Platform_Accessibility: items?.Users_Details?.Platform_Accessibility,
      Account_Accessibility: items?.Users_Details?.Account_Accessibility,
      Group_Visibility: items?.Group_Visibility,
      User_Merchant_AcctLinks_Details: items?.User_Merchant_AcctLinks_Details,
      Manager_ID: items?.ManagerStatus?.Manager_id,
      full_name: items?.full_name,
      Users_Details: items?.Users_Details,
      Created_By: items?.Created_By,
      Allowed_IP: items?.ManagerStatus?.Allowed_IP,
      First_Manager: items?.First_Manager,
      MainEmail: items?.Manager_Details?.Email,
    }));

    const resultWhenId = completeData?.data?.map((items) => ({
      Business_Name: items?.Business_Details?.Business_Name,
      Email: items?.Email,
      Manager_uid: items.Manager_uid,
      _id: items?._id,
      First_Name: items?.First_Name,
      Last_Name: items?.Last_Name,
      Phone_Number: items?.Phone_Number,
      Status_Code: items?.ManagerStatus?.Status
        ? items?.ManagerStatus?.Status
        : null,
      User_Id: items.Manager_Details?.User_Id,
      Bussines_id: items?.Business_Details?._id,
      Updated_date: items?.ManagerStatus?.Updated_date,
      Manager_name: items?.full_name,
      Status_Code_Value: items?.Business_Details?.Status_Code,
      Type: items?.Type,
      Platform_Accessibility: items?.Users_Details?.Platform_Accessibility,
      Account_Accessibility: items?.Users_Details?.Account_Accessibility,
      Group_Visibility: items?.Group_Visibility,
      User_Merchant_AcctLinks_Details: items?.User_Merchant_AcctLinks_Details,
      Manager_ID: items?.ManagerStatus?.Manager_id,
      full_name: items?.full_name,
      Users_Details: items?.Users_Details,
      Created_By: items?.Created_By,
      Allowed_IP: items?.ManagerStatus?.Allowed_IP,
      First_Manager: items?.First_Manager,
      MainEmail: items?.Manager_Details?.Email,
    }));

    const newResult =
      id == null &&
        props.managerListData &&
        props.managerListData?.managerListNames?.status === true
        ? result
        : resultWhenId;

    setTransformedData(newResult || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completeData, id]);

  React.useEffect(() => {
    const getManagerTypeLabel = (row) => {
      if (row?.Type === "main" && row?.First_Manager === true) {
        return "Primary Manager";
      }
      if (row?.Type === "main" && row?.First_Manager === false) {
        return "Secondary Manager";
      }
      return "Sub-Manager";
    };

    const applyFilters = (data) =>
      data.filter((row) => {
        const matchesBusinessName = props.managerListData?.searchBusinessName
          ? row.Business_Name?.toLowerCase().includes(
            props.managerListData.searchBusinessName.toLowerCase()
          )
          : true;
        const matchesEmail = props.managerListData?.searchEmail
          ? row.Email?.toLowerCase().includes(
            props.managerListData.searchEmail.toLowerCase()
          )
          : true;
        const matchesManagerUID = props.managerListData?.searchManagerUID
          ? row.Manager_uid?.toLowerCase().includes(
            props.managerListData.searchManagerUID.toLowerCase()
          )
          : true;
        const matchesStatus = props.managerListData?.searchStatus
          ? Array.isArray(row.Status_Code) &&
          row.Status_Code.some(
            (status) =>
              status.Status?.toLowerCase() ===
              props.managerListData.searchStatus.toLowerCase()
          )
          : true;
        const matchesManagerId = props.managerListData?.searchManagerId
          ? row._id
            ?.toLowerCase()
            .includes(props.managerListData.searchManagerId.toLowerCase())
          : true;
        const matchesPlatform = props.managerListData?.searchPlatform
          ? (row.Platform_Accessibility || "")
            .toString()
            .toLowerCase() === props.managerListData.searchPlatform.toLowerCase()
          : true;
        const matchesManagerType = props.managerListData?.searchManagerType
          ? getManagerTypeLabel(row) === props.managerListData.searchManagerType
          : true;
        return (
          matchesBusinessName &&
          matchesEmail &&
          matchesManagerUID &&
          matchesStatus &&
          matchesManagerId &&
          matchesPlatform &&
          matchesManagerType
        );
      });

    const getSortValue = (row, columnId) => {
      if (columnId === "Manager_name") {
        return row?.Manager_name || `${row?.First_Name || ""} ${row?.Last_Name || ""}`.trim() || "";
      }
      if (columnId === "Manager_Type") {
        if (row?.Type === "main" && row?.First_Manager === true) {
          return "Primary Manager";
        }
        if (row?.Type === "main" && row?.First_Manager === false) {
          return "Secondary Manager";
        }
        return "Sub-Manager";
      }
      if (columnId === "Platform") {
        return row?.Platform_Accessibility || "";
      }
      if (columnId === "RTP_Status") {
        return Array.isArray(row?.Status_Code)
          ? row.Status_Code.find((item) => item?.Service_Code === "RTP")?.Status || ""
          : "";
      }
      if (columnId === "VIKExclude_Status") {
        return Array.isArray(row?.Status_Code)
          ? row.Status_Code.find((item) => item?.Service_Code === "VIKExclude")?.Status || ""
          : "";
      }
      if (columnId === "ACH_Status") {
        return Array.isArray(row?.Status_Code)
          ? row.Status_Code.find((item) => item?.Service_Code === "ACH")?.Status || ""
          : "";
      }
      return getPropertyNested(row, columnId);
    };

    const sortData = (data) =>
      data.sort((a, b) => {
        const aValue = getSortValue(a, orderBy);
        const bValue = getSortValue(b, orderBy);

        if (aValue === null || aValue === undefined) {
          return order === "asc" ? -1 : 1;
        }
        if (bValue === null || bValue === undefined) {
          return order === "asc" ? 1 : -1;
        }

        if (typeof aValue === "string" || typeof bValue === "string") {
          const aString = String(aValue).toLowerCase();
          const bString = String(bValue).toLowerCase();
          return order === "asc"
            ? aString.localeCompare(bString)
            : bString.localeCompare(aString);
        }

        return order === "asc"
          ? (aValue > bValue ? 1 : -1)
          : (aValue < bValue ? 1 : -1);
      });

    const filterAndSortData = (data) => {
      const filteredData = applyFilters(data);
      const sortedData = sortData(filteredData);
      return sortedData;
    };
    const updateRows = () => {
      const filteredAndSortedData = filterAndSortData(transformedData);
      setTotalCount(filteredAndSortedData.length);
      const paginatedData = filteredAndSortedData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );

      const newRows = paginatedData.map((v) => {
        const Id = v._id;
        const Business_Name = v?.Business_Name;
        const Email = v.Email;
        const First_Name = v.First_Name;
        const Last_Name = v.Last_Name;
        const Phone_Number = v.Phone_Number;
        const Business_Phone = v.Phone_Number;
        const Updated_date = moment(v.Updated_date)
          .tz("America/New_York")
          .format("MM/DD/YYYY");
        const Manager_name = v.Manager_name;
        const Manager_uid = v.Manager_uid;
        const Status_Code = v.Status_Code;
        const Bussines_id = v.Bussines_id;
        const Status_Code_Value = v.Status_Code_Value;
        const Type = v.Type;
        const Platform_Accessibility = v.Platform_Accessibility;
        const Account_Accessibility = v.Account_Accessibility;
        const Group_Visibility = v.Group_Visibility;
        const User_Merchant_AcctLinks_Details =
          v.User_Merchant_AcctLinks_Details;
        const Manager_ID = v.Manager_ID;
        const full_name = v.full_name;
        const Users_Details = v.Users_Details;
        const Created_By = v.Created_By;
        const Allowed_IP = v.Allowed_IP;
        const First_Manager = v.First_Manager;
        const MainEmail = v.MainEmail;

        return createData(
          Business_Name,
          Manager_name,
          Manager_uid,
          Email,
          First_Name,
          Last_Name,
          Phone_Number,
          Business_Phone,
          Updated_date,
          Status_Code,
          Bussines_id,
          Status_Code_Value,
          Type,
          Platform_Accessibility,
          Account_Accessibility,
          Group_Visibility,
          User_Merchant_AcctLinks_Details,
          Id,
          Manager_ID,
          full_name,
          Users_Details,
          Created_By,
          Allowed_IP,
          First_Manager,
          MainEmail
        );
      });

      setRows(newRows);
    };

    updateRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    rowsPerPage,
    order,
    orderBy,
    transformedData,
    props.managerListData,
  ]);

  const exportedBy =
    props.mainData.users.userDetailsById &&
    props.mainData.users.userDetailsById?.Users_Data[0].Email;
  const exportedByFname =
    props.mainData.users.userDetailsById &&
    props.mainData.users.userDetailsById?.Users_Data[0].FName;
  const exportedByLname =
    props.mainData.users.userDetailsById &&
    props.mainData.users.userDetailsById?.Users_Data[0].LName;
  const exportListData = () => {
    const allManagerData = props?.managerListData?.managerListNames || [];
    let filteredList = allManagerData.data;
    if (
      props?.managerListData?.searchBusinessName ||
      props?.managerListData?.searchEmail ||
      props?.managerListData?.searchManagerName ||
      props?.managerListData?.searchManagerUID ||
      props?.managerListData?.searchStatus ||
      props?.managerListData?.searchPlatform ||
      props?.managerListData?.searchManagerType
    ) {
      filteredList = allManagerData.data.filter((row) => {
        const getManagerTypeLabel = (managerRow) => {
          if (managerRow?.Type === "main" && managerRow?.First_Manager === true) {
            return "Primary Manager";
          }
          if (managerRow?.Type === "main" && managerRow?.First_Manager === false) {
            return "Secondary Manager";
          }
          return "Sub-Manager";
        };

        const matchesBusinessName = props?.managerListData?.searchBusinessName
          ? row.Business_Details?.Business_Name.toLowerCase().includes(
            props?.managerListData?.searchBusinessName.toLowerCase()
          )
          : true;
        const matchesEmail = props?.managerListData?.searchEmail
          ? row.Email.toLowerCase().includes(
            props?.managerListData?.searchEmail.toLowerCase()
          )
          : true;
        const matchesManagerUID = props?.managerListData?.searchManagerUID
          ? row.Manager_uid.toLowerCase().includes(
            props?.managerListData?.searchManagerUID.toLowerCase()
          )
          : true;
        const matchesManagerId = props?.managerListData?.searchManagerId
          ? row._id
            .toLowerCase()
            .includes(props?.managerListData?.searchManagerId.toLowerCase())
          : true;
        const matchesPlatform = props?.managerListData?.searchPlatform
          ? (row?.Users_Details?.Platform_Accessibility || "").toString().toLowerCase() ===
          props?.managerListData?.searchPlatform.toLowerCase()
          : true;
        const matchesManagerType = props?.managerListData?.searchManagerType
          ? getManagerTypeLabel(row) === props?.managerListData?.searchManagerType
          : true;
        return (
          matchesBusinessName &&
          matchesEmail &&
          matchesManagerUID &&
          matchesManagerId &&
          matchesPlatform &&
          matchesManagerType
        );
      });
    }

    const mappedLogs = filteredList.map((row) => ({
      "Business Name": row.Business_Details?.Business_Name,
      "Manager Name": row.full_name,
      "Manager Type":
        row.Type === "main" && row.First_Manager === true
          ? "Primary Manager"
          : row.Type === "main" && row.First_Manager === false
            ? "Secondary Manager"
            : "Sub-Manager",

      "Manager UID": row.Manager_uid,
      Email: row.Email,
      "Phone Number": row.Phone_Number,
      "Update Date": moment(row.Updated_date)
        .tz("America/New_York")
        .format("MM/DD/YYYY"),
      Platform: row?.Users_Details?.Platform_Accessibility,
      "RTP Status": Array.isArray(row?.ManagerStatus?.Status)
        ? row.ManagerStatus.Status.find((item) => item.Service_Code === "RTP")
          ?.Status || "N/A"
        : "N/A",

      "ACH Status": Array.isArray(row?.ManagerStatus?.Status)
        ? row.ManagerStatus.Status.find((item) => item.Service_Code === "ACH")
          ?.Status || "N/A"
        : "N/A",
    }));
    exportToCSVProvider(
      mappedLogs,
      "Manager Details",
      chipValue,
      exportedBy,
      exportedByFname,
      exportedByLname
    );
  };

  const exportToPDFList = () => {
    const allManagerData = props?.managerListData?.managerListNames || [];
    const applyFilters = (data) =>
      data.filter((row) => {
        const getManagerTypeLabel = (managerRow) => {
          if (managerRow?.Type === "main" && managerRow?.First_Manager === true) {
            return "Primary Manager";
          }
          if (managerRow?.Type === "main" && managerRow?.First_Manager === false) {
            return "Secondary Manager";
          }
          return "Sub-Manager";
        };

        const matchesBusinessName = props?.managerListData?.searchBusinessName
          ? row.Business_Details?.Business_Name.toLowerCase().includes(
            props?.managerListData?.searchBusinessName.toLowerCase()
          )
          : true;
        const matchesEmail = props?.managerListData?.searchEmail
          ? row.Email.toLowerCase().includes(
            props?.managerListData?.searchEmail.toLowerCase()
          )
          : true;
        const matchesManagerUID = props?.managerListData?.searchManagerUID
          ? row.Manager_uid.toLowerCase().includes(
            props?.managerListData?.searchManagerUID.toLowerCase()
          )
          : true;
        const matchesManagerId = props?.managerListData?.searchManagerId
          ? row._id
            .toLowerCase()
            .includes(props?.managerListData?.searchManagerId.toLowerCase())
          : true;
        const matchesPlatform = props?.managerListData?.searchPlatform
          ? (row?.Users_Details?.Platform_Accessibility || "").toString().toLowerCase() ===
          props?.managerListData?.searchPlatform.toLowerCase()
          : true;
        const matchesManagerType = props?.managerListData?.searchManagerType
          ? getManagerTypeLabel(row) === props?.managerListData?.searchManagerType
          : true;
        return (
          matchesBusinessName &&
          matchesEmail &&
          matchesManagerUID &&
          matchesManagerId &&
          matchesPlatform &&
          matchesManagerType
        );
      });

    let dataToExport = allManagerData.data;

    dataToExport = applyFilters(dataToExport);

    const totalCount = dataToExport.length;
    if (totalCount > 0) {
      const mappedLogs = dataToExport.map((row) => [
        row.Business_Details?.Business_Name,
        row.full_name,
        row.Manager_uid,
        row.Email,
        row.Phone_Number,
        moment(row.Updated_date).tz("America/New_York").format("MM/DD/YYYY"),
        row.Status_Code,
      ]);

      const headersName = [
        "Business Name",
        "Manager Name",
        "Manager UID",
        "Email",
        "Phone Number",
        "Update Date",
        "Status",
      ];

      exportToPDF(
        headersName,
        mappedLogs,
        "Manager List",
        chipValue,
        exportedBy,
        exportedByFname,
        exportedByLname,
        totalCount
      );
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
  };

  // Helper function to safely access nested properties
  const getPropertyNested = (object, property) => {
    const properties = property.split(".");
    let value = object;

    for (const prop of properties) {
      value = value[prop];
      if (value === undefined || value === null) return undefined;
      if (Array.isArray(value)) {
        value = value.length > 0 ? value[0] : undefined;
      }
    }

    return value;
  };
  const handleAssignGroup = (value) => {
    const payload = typeof value === "object" && value !== null
      ? value
      : { email: value };
    props.getMerchantGroupCodePortfolios(payload);
  };

  const displayAndDeleteChips = (searchData) => {
    const chips = [];
    if (searchData.searchBusinessName) {
      chips.push(`Business Name: ${searchData.searchBusinessName}`);
    }
    if (searchData.searchManagerUID) {
      chips.push(`Manager UID: ${searchData.searchManagerUID}`);
    }
    if (searchData.searchEmail) {
      chips.push(`Email: ${searchData.searchEmail}`);
    }
    if (searchData.searchStatus) {
      chips.push(`Status: ${searchData.searchStatus}`);
    }
    if (searchData.searchPlatform) {
      chips.push(`Platform: ${searchData.searchPlatform}`);
    }
    if (searchData.searchManagerType) {
      chips.push(`Manager Type: ${searchData.searchManagerType}`);
    }
    if (searchData.searchManagerName) {
      chips.push(`Manager Name: ${searchData.searchManagerName}`);
    }
    setChipValue(chips);
  };

  const handleDeleteChip = (chipToDelete) => {
    const updatedChips = chipValue.filter((chip) => chip !== chipToDelete);
    setChipValue(updatedChips);

    const updatedFormData = {
      searchBusinessName: "",
      searchEmail: "",
      searchStatus: "",
      searchManagerUID: "",
      searchManagerName: "",
      searchManagerId: "",
      searchPlatform: "",
      searchManagerType: "",
    };

    updatedChips.forEach((chip) => {
      const [key, value] = chip.split(":").map((item) => item.trim());
      switch (key) {
        case "Email":
          updatedFormData.searchEmail = value;
          break;
        case "Business Name":
          updatedFormData.searchBusinessName = value;
          break;
        case "Status":
          updatedFormData.searchStatus = value;
          break;
        case "Manager Name":
          updatedFormData.searchManagerName = value;
          updatedFormData.searchManagerId =
            value !== null || value !== ""
              ? props.managerListData?.searchManagerId
              : "";
          break;
        case "Manager UID":
          updatedFormData.searchManagerUID = value;
          break;
        case "Platform":
          updatedFormData.searchPlatform = value;
          break;
        case "Manager Type":
          updatedFormData.searchManagerType = value;
          break;
        default:
          break;
      }
    });

    props.clearFormDataManager();
    props.setFormDataManager(updatedFormData);
    setPage(0);
  };

  const handleBack = () => {
    localStorage.setItem("BackPressed", true);
    props.history.push(`/${props.mainData.app.layout}/MerchantSetup`);
  };

  const handleRefresh = () => {
    const profileCode = menu?.Role_Permission_Data?.Profile_Code;
    const Manager_Id = menu?.Manager_Id;
    if (profileCode === profileCodePermissionCheck.profileCode.SA) {
      let payload = null;
      if (profileId === null || profileId === "null") {
        payload = {
          Bussines_id: id || null,
          Manager_Id,
          recordPerPage: 999999,
        };
      } else {
        payload = {
          Bussines_id: id || null,
          Profile_Id: profileId,
          recordPerPage: 999999,
        };
      }
      dispatch(getManagerListDataNames(payload));
    } else {
      const payload = {
        Bussines_id: id || null,
        Profile_Code: menu?.Role_Permission_Data?.Profile_Code,
        recordPerPage: 999999,
      };
      dispatch(getManagerListDataNames(payload));
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        enqueueSnackbar(`${text} copied to clipboard`, { variant: "success" });
      })
      .catch(() => {
        enqueueSnackbar("Failed to copy text to clipboard", {
          variant: "error",
        });
      });
  };

  const getStatusDotColor = (status) => {
    const normalized = String(status || "").trim();
    if (normalized === "Active") return "#2ab673";
    if (normalized === "Inactive") return "#8a8f98";
    if (normalized === "Invited") return "#2f7df6";
    if (
      normalized === "Pending Activation" ||
      normalized === "Activation Pending" ||
      normalized === "Service Activation Pending"
    ) return "#f59e0b";
    if (normalized === "Awaiting Business Submission") return "#f4c542";
    return "#8a8f98";
  };

  const getStatusPillStyle = (status) => {
    const normalized = String(status || "").trim();
    if (normalized === "Active") return { background: "#eafaf1", color: "#1b8f5d" };
    if (normalized === "Inactive") return { background: "#f2f4f7", color: "#5c6674" };
    if (normalized === "Invited") return { background: "#eaf3ff", color: "#2359c6" };
    if (
      normalized === "Pending Activation" ||
      normalized === "Activation Pending" ||
      normalized === "Service Activation Pending"
    ) return { background: "#fff4df", color: "#b76a00" };
    if (normalized === "Awaiting Business Submission") return { background: "#fff8de", color: "#8a6a00" };
    return { background: "#f2f4f7", color: "#5c6674" };
  };

  const renderStatusSummary = (row) => {
    if (!isArray(row?.Status_Code)) {
      return row?.Status_Code || null;
    }

    const statusItems = row.Status_Code.filter(
      (item) =>
        item &&
        ["RTP", "VIKExclude", "ACH", "Chargeback"].includes(item.Service_Code)
    );

    if (!statusItems.length) {
      return null;
    }

    const statusRowKey = `${row.Id}-${row.Bussines_id}`;
    const isOpen = openStatusRowId === statusRowKey;
    const dotSize = 11;

    return (
      <div style={{ position: "relative", display: "inline-flex", alignItems: "center", overflow: "visible" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            cursor: "pointer",
            padding: "4px 8px 4px 6px",
            borderRadius: "999px",
            minHeight: "24px",
            lineHeight: 1,
          }}
          data-status-summary-trigger
          onClick={(event) => {
            setOpenStatusRowId(isOpen ? null : statusRowKey);
            setStatusAnchorEl(isOpen ? null : event.currentTarget);
          }}
        >
          {statusItems.map((item, idx) => (
            <span
              key={`${row.Id}-${item.Service_Code || idx}`}
              title={item.Status || item.Service_Code}
              style={{
                width: `${dotSize}px`,
                height: `${dotSize}px`,
                borderRadius: "50%",
                backgroundColor: getStatusDotColor(item.Status),
                display: "inline-block",
                boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
                verticalAlign: "middle",
              }}
            />
          ))}
          <span
            style={{
              fontSize: "10px",
              color: "#5b6470",
              marginLeft: "1px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              transform: "translateY(-1px)",
            }}
          >
            ▾
          </span>
        </div>

        {isOpen && (
          <ClickAwayListener
            onClickAway={(event) => {
              if (event.target.closest?.("[data-status-summary-trigger]")) {
                return;
              }
              setOpenStatusRowId(null);
              setStatusAnchorEl(null);
            }}
          >
            <Popper
              open={isOpen}
              anchorEl={statusAnchorEl}
              placement="bottom-end"
              modifiers={{
                flip: { enabled: true },
                preventOverflow: {
                  enabled: true,
                  boundariesElement: "window",
                  padding: 8,
                },
              }}
              style={{ zIndex: 50 }}
            >
            <div
              style={{
                width: "240px",
                maxWidth: "calc(100vw - 32px)",
                background: "#fff",
                borderRadius: "12px",
                boxShadow: "0 10px 28px rgba(0,0,0,0.14)",
                border: "1px solid rgba(0, 0, 0, 0.06)",
                padding: "8px",
              }}
            >
              {statusItems.map((item, idx) => {
                const statusPillStyle = getStatusPillStyle(item.Status);
                return (
                  <div
                    key={`${row.Id}-popup-${item.Service_Code || idx}`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 8px",
                      marginBottom: idx === statusItems.length - 1 ? "0" : "6px",
                      background: "#f8fafc",
                      borderRadius: "10px",
                    }}
                  >
                    <span
                      style={{
                        width: "11px",
                        height: "11px",
                        borderRadius: "50%",
                        backgroundColor: getStatusDotColor(item.Status),
                        display: "inline-block",
                        boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
                        flexShrink: 0,
                      }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: 600,
                          color: "#2d3748",
                          lineHeight: "1.3",
                          marginBottom: "2px",
                        }}
                      >
                        {item.Service_Code || "Service"}
                      </div>
                      <div
                        style={{
                          ...statusPillStyle,
                          display: "inline-flex",
                          alignItems: "center",
                          borderRadius: "999px",
                          fontSize: "11px",
                          fontWeight: 600,
                          lineHeight: "1.2",
                          padding: "3px 8px",
                        }}
                      >
                        {item.Status || "N/A"}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            </Popper>
          </ClickAwayListener>
        )}
      </div>
    );
  };

  const userType = localStorage.getItem("userType");
  const createPermission = actionPermission(
    permissionCheck.Category.setup,
    permissionCheck.Page.managerList,
    permissionCheck.option.add
  );

  return (
    <>
      <TableContainer className={classes.TableContainer} component={Paper}>
        {windowWidth && (
          <Grid container className={classes.searchContainer}>
            <Grid item className={classes.margin}>
              <div className={classes.searchWrapper1}>
                {id !== null && (
                  <IconsTooltip title="Back" placement="top">
                    <div style={{ display: "flex", alignSelf: "flex-end" }}>
                      <ArrowBackIcon color="primary" onClick={handleBack} />
                    </div>
                  </IconsTooltip>
                )}
                <div className={classes.searchWrapper}>
                  <SearchFields
                    searchBar={searchBar}
                    handleSearchClose={handleSearchClose}
                    handleSearchOpen={handleSearchOpen}
                    Fields={() => (
                      <SearchDialogManager
                        close={() => handleSearchClose()}
                        seacrhChipData={(data) => displayAndDeleteChips(data)}
                        clearChips={() => setChipValue([])}
                      />
                    )}
                  />
                  <IconsTooltip title="Refresh" placement="top">
                    <div className={classes.appSvgIcons}>
                      <SyncIcon
                        style={{ marginRight: "10px" }}
                        fontSize="large"
                        color="primary"
                        onClick={handleRefresh}
                      />
                    </div>
                  </IconsTooltip>
                  <IconsTooltip title="Export" placement="top">
                    <div className={classes.appSvgIcons}>
                      <ExportIcon
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleToggle}
                        ref={anchorRef}
                      />
                    </div>
                  </IconsTooltip>
                  <Popper
                    open={openImportFileModal}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                    style={{
                      zIndex: "10",
                    }}
                  >
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{
                          transformOrigin:
                            placement === "bottom-start"
                              ? "left top"
                              : "left bottom",
                        }}
                      >
                        <Paper>
                          <ClickAwayListener onClickAway={handleCloseModel}>
                            <MenuList
                              id="menu-list-grow"
                              onKeyDown={handleListKeyDown}
                            >
                              {actionPermission(
                                permissionCheck.Category.setup,
                                permissionCheck.Page.merchant,
                                permissionCheck.option.exportToExcel
                              ) && (
                                  <MenuItem
                                    onClick={exportListData}
                                    style={{
                                      fontSize: "14px",
                                    }}
                                  >
                                    Export to Excel
                                  </MenuItem>
                                )}
                              {actionPermission(
                                permissionCheck.Category.setup,
                                permissionCheck.Page.merchant,
                                permissionCheck.option.exportToPdf
                              ) && (
                                  <MenuItem
                                    onClick={exportToPDFList}
                                    style={{
                                      fontSize: "14px",
                                    }}
                                  >
                                    Export to PDF
                                  </MenuItem>
                                )}
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>

                  {actionPermission(
                    permissionCheck.Category.setup,
                    permissionCheck.Page.managerList,
                    permissionCheck.option.add
                  ) &&
                    profileCode !== profileCodePermissionCheck.profileCode.VCS && profileCode !== profileCodePermissionCheck.profileCode.STD &&
                    props?.managerListData?.emailData1?.Mg_Status ===
                    MgStatus.Active && (
                      <IconsTooltip title="Add" placement="top">
                        <div className={classes.appSvgIcons}>
                          <AddIconSvg onClick={() => handleAddIconClick()} />
                        </div>
                      </IconsTooltip>
                    )}
                  {actionPermission(
                    permissionCheck.Category.setup,
                    permissionCheck.Page.managerList,
                    permissionCheck.option.add
                  ) &&
                    profileCode ===
                    profileCodePermissionCheck.profileCode.VCS && (
                      <IconsTooltip title="Add" placement="top">
                        <div className={classes.appSvgIcons}>
                          <AddIconSvg onClick={() => handleAddIconClick()} />
                        </div>
                      </IconsTooltip>
                    )}
                  {inviteManagerModalOpen && (
                    <InviteManagerModal
                      open={inviteManagerModalOpen}
                      onClose={() => setInviteManagerModalOpen(false)}
                      props={props}
                      rows={rows}
                      sendInviteManagerApiCall={props.sendInviteManagerApiCall}
                      emptyGroupCodeReduxState={props.emptyGroupCodeReduxState}
                      submitManagerApiCall={props.submitManagerApiCall}
                      Bussines_id={id}
                      rowForEdit={rowForEdit}
                      handleAssignGroup={handleAssignGroup}
                      handleRefresh={handleRefresh}
                    />
                  )}
                  {whitelistedApiModalOpen && (
                    <WhitelistedApiModal
                      open={whitelistedApiModalOpen}
                      onClose={() => setWhitelistedApiModalOpen(false)}
                      props={props}
                      rows={rows}
                      sendInviteManagerApiCall={props.sendInviteManagerApiCall}
                      emptyGroupCodeReduxState={props.emptyGroupCodeReduxState}
                      submitManagerApiCall={props.submitManagerApiCall}
                      Bussines_id={id}
                      rowForEdit={rowForEdit}
                      handleAssignGroup={handleAssignGroup}
                      handleRefresh={handleRefresh}
                      handleApiModalClick={handleApiModalClick}
                      submitIPAddressApiCall={props.submitIPAddressApiCall}
                    />
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        )}
        {!windowWidth && (
          <Grid container className={classes.searchContainer}>
            <Grid item className={classes.margin} style={{ display: "flex" }}>
              <div className={classes.searchWrapper}>
                <SearchFields
                  searchBar={searchBar}
                  handleSearchClose={handleSearchClose}
                  handleSearchOpen={handleSearchOpen}
                  Fields={() => (
                    <SearchDialogManager
                      close={() => handleSearchClose()}
                      seacrhChipData={(data) => displayAndDeleteChips(data)}
                      clearChips={() => setChipValue([])}
                    />
                  )}
                />
                <IconsTooltip title="Export" placement="top">
                  <div className={classes.appSvgIcons}>
                    <ExportIcon
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleToggle}
                      ref={anchorRef}
                    />
                  </div>
                </IconsTooltip>
                <Popper
                  open={openImportFileModal}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  placement="bottom-start"
                  transition
                  disablePortal
                  style={{
                    zIndex: "10",
                  }}
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom-start"
                            ? "left top"
                            : "left bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleCloseModel}>
                          <MenuList
                            id="menu-list-grow"
                            onKeyDown={handleListKeyDown}
                          >
                            {actionPermission(
                              permissionCheck.Category.setup,
                              permissionCheck.Page.merchant,
                              permissionCheck.option.exportToExcel
                            ) && (
                                <MenuItem
                                  style={{
                                    fontSize: "14px",
                                  }}
                                >
                                  Export to Excel
                                </MenuItem>
                              )}
                            {actionPermission(
                              permissionCheck.Category.setup,
                              permissionCheck.Page.merchant,
                              permissionCheck.option.exportToPdf
                            ) && (
                                <MenuItem
                                  style={{
                                    fontSize: "14px",
                                  }}
                                >
                                  Export to PDF
                                </MenuItem>
                              )}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
                {userType === "Internal" && createPermission && (
                  <IconsTooltip title="Add" placement="top">
                    <div className={classes.appSvgIcons}>
                      <AddIconSvg onClick={() => handleAddIconClick()} />
                    </div>
                  </IconsTooltip>
                )}
                {inviteManagerModalOpen && (
                  <InviteManagerModal
                    open={inviteManagerModalOpen}
                    onClose={() => setInviteManagerModalOpen(false)}
                    props={props}
                    rows={rows}
                    sendInviteManagerApiCall={props.sendInviteManagerApiCall}
                    emptyGroupCodeReduxState={props.emptyGroupCodeReduxState}
                    submitManagerApiCall={props.submitManagerApiCall}
                    Bussines_id={id}
                    rowForEdit={rowForEdit}
                    handleAssignGroup={handleAssignGroup}
                    handleRefresh={handleRefresh}
                  />
                )}
                {whitelistedApiModalOpen && (
                  <WhitelistedApiModal
                    open={whitelistedApiModalOpen}
                    onClose={() => setWhitelistedApiModalOpen(false)}
                    props={props}
                    rows={rows}
                    sendInviteManagerApiCall={props.sendInviteManagerApiCall}
                    emptyGroupCodeReduxState={props.emptyGroupCodeReduxState}
                    submitManagerApiCall={props.submitManagerApiCall}
                    Bussines_id={id}
                    rowForEdit={rowForEdit}
                    handleAssignGroup={handleAssignGroup}
                    handleRefresh={handleRefresh}
                    handleApiModalClick={handleApiModalClick}
                    submitIPAddressApiCall={props.submitIPAddressApiCall}
                  />
                )}
              </div>
            </Grid>
          </Grid>
        )}
        <SearchChips
          searchValues={chipValue}
          handleDeleteChip={(chip, index) => handleDeleteChip(chip, index)}
        />
        <Table className={classes.table} aria-label="simple table">
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows?.length}
          />
          <TableBody>
            {!isEmpty(rows) ? (
              rows.map((row, index) => (
                <TableRow className={classes.cellHeadSign} key={index}>
                  <TableCell className={classes.cellText}>
                    {row.Business_Name}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Manager_name
                      ? row.Manager_name
                      : `${row.First_Name} ${row.Last_Name}`}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {/* if(type == "main" && first_manager = true) Manager Type =
                    Primary Manager else if(type == "main" && first_manager =
                    null || "false" || "") Manager Type = Secondary Manager else
                    if (type == "sub") Manager Type = Sub-Manager */}
                    {row.Type === "main" && row.First_Manager === true
                      ? "Primary Manager"
                      : row.Type === "main" && row.First_Manager === false
                        ? "Secondary Manager"
                        : "Sub-Manager"}
                  </TableCell>
                  <TableCell
                    className={classes.cellText}
                    align="left"
                    onClick={() => copyToClipboard(row.Manager_uid)}
                  >
                    <IconsTooltip
                      title={row.Manager_uid ? "Click to copy" : ""}
                      placement="top"
                    >
                      <span>{row.Manager_uid}</span>
                    </IconsTooltip>
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Email}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Business_Phone}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left">
                    {row.Updated_date}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left" style={{ overflow: "visible" }}>
                    {row.Platform_Accessibility}
                  </TableCell>
                  <TableCell className={classes.cellText} align="left" style={{ overflow: "visible" }}>
                    {renderStatusSummary(row)}
                  </TableCell>
                  <TableCell className={classes.cellText}>
                    <ManagerSetupMenu
                      id={row.Id}
                      details={row}
                      provider
                      {...props}
                      handleAddIconClick={() => handleAddIconClick(row)}
                      handleWebhookModalClick={() =>
                        handleWebhookModalClick(row)
                      }
                      handleApiModalClick={() => handleApiModalClick(row)}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell className="no-data" colSpan={12}>
                  <img
                    src={noDataImage}
                    alt=""
                    className={classes.noDataImage}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody >
          {
            rows?.length ? (
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[
                      5,
                      10,
                      25,
                      {
                        label: "All",
                        value: totalCount,
                      },
                    ]}
                    colSpan={12}
                    count={totalCount}
                    rowsPerPage={rowsPerPage || 5}
                    page={page}
                    SelectProps={{
                      inputProps: { "aria-label": "rows per page" },
                      MenuProps: { classes: { paper: classes.selectDropdown } },
                    }}
                    classes={{ menuItem: classes.menuItem }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter >
            ) : (
              ""
            )}
        </Table >
      </TableContainer >
    </>
  );
};

ProviderReport.propTypes = {
  tableData: PropTypes.object,
  history: PropTypes.any,
  changeSingleStatus: PropTypes.func,
  userDetails: PropTypes.object,
  mainData: PropTypes.object,
  getRtpAch: PropTypes.func,
  getMerchantListDataExport: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getManagerListData: PropTypes.func,
  getManagerListDataByID: PropTypes.func,
  sendInviteApiCall: PropTypes.func,
  emptyReduxState: PropTypes.func,
  sendInviteManagerApiCall: PropTypes.func,
  reSendInviteManagerApiCall: PropTypes.func,
  submitIPAddressApiCall: PropTypes.func,
  submitManagerApiCall: PropTypes.func,
  getManagerListDataNames: PropTypes.func,
  getEmailData1: PropTypes.func,
  getMerchantGroupCodePortfolios: PropTypes.func,
  emptyGroupCodeReduxState: PropTypes.func,
};

const mapStateToProps = (app) => ({
  tableData: app.provideRegistration,
  userDetails: app.app,
  mainData: app,
  roles: app.roles,
  merchantListData: app.merchantInformation,
  managerListData: app.merchantInformation,
  managerListDataById: app.merchantInformation,
  achRtpList: app.merchantInformation.achRtpList,
  merchantGroupCodeListPortfolios:
    app.merchantInformation.merchantGroupCodeListPortfolios,
});
export default connect(mapStateToProps, {
  changeSingleStatus,
  getMerchantListDataExport,
  getMerchantListData,
  getManagerListData,
  getManagerListDataByID,
  sendInviteApiCall,
  emptyReduxState,
  sendInviteManagerApiCall,
  reSendInviteManagerApiCall,
  emptyGroupCodeReduxState,
  submitIPAddressApiCall,
  submitManagerApiCall,
  setFormDataManager,
  clearFormDataManager,
  getEmailData1,
  getRtpAch,
  getMerchantGroupCodePortfolios,
})(ProviderReport);
